import { LoginWizard } from './LoginWizard';

export default LoginWizard;
